import {NgModule}             from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';

import {AuthenticationGuard} from "./services/route-can-activates/authentication-guard.service";
import {AlreadyLoggedIn} from "./services/route-can-activates/already-logged-in.service";

import {LoginComponent} from "./components/login/login.component";
import {PasswordResetComponent} from "./components/password-reset/password-reset.component";
import {PasswordResetCreateComponent} from "./components/password-reset-create/password-reset-create.component";
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {OccupancyComponent} from "./components/occupancy/occupancy.component";
import {ReportsComponent} from "./components/reports/reports.component";
import {LinkPortalComponent} from "./components/link-portal/link-portal.component";
import {LicenceManagementComponent} from "./components/licence-mangement/licence-management.component";
import {AlarmComponent} from "./components/alarms/alarm.component";
import {DeploymentComponent} from "./components/deployment/deployment.component";
import {TotesComponent} from "./components/totes/totes.component";

const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },

    // Public routes
    { path: 'login', component: LoginComponent, canActivate: [AlreadyLoggedIn] },
    { path: 'password-reset/:token', component: PasswordResetComponent },

    // Protected routes
    { path: 'licence-management', component: LicenceManagementComponent, canActivate: [AuthenticationGuard] },
    { path: 'password-reset-create', component: PasswordResetCreateComponent, canActivate: [AuthenticationGuard] },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthenticationGuard] },
    { path: 'occupancy', component: OccupancyComponent, canActivate: [AuthenticationGuard] },
    { path: 'alarms', component: AlarmComponent, canActivate: [AuthenticationGuard] },
    { path: 'reports', component: ReportsComponent, canActivate: [AuthenticationGuard] },
    { path: 'portal', component: LinkPortalComponent, canActivate: [AuthenticationGuard] },
    { path: 'deployment', component: DeploymentComponent, canActivate: [AuthenticationGuard] },
    { path: 'totes', component: TotesComponent, canActivate: [AuthenticationGuard] },
    { path: 'totes/:returnUrl', component: TotesComponent, canActivate: [AuthenticationGuard] }
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ],
    providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app-routing.module.ts